module.exports = __webpack_public_path__ + "img/base.0bcf94c5.png";